import React from 'react';
import ReactDOM from 'react-dom';
import { Initializer } from 'common/types/initializers';
import { Reconnect } from 'src/federation/Reconnect';
import Wahanda from 'common/wahanda';
import type {
  CancellationUnavailableProps,
  FinalConfirmationProps,
  MultiBookingCancellationProps,
  RescheduleOrCancelProps,
} from 'reconnect-types/moduleFederation';

export type FinalCancellationProps = FinalConfirmationProps;
export type {
  CancellationUnavailableProps,
  MultiBookingCancellationProps,
  RescheduleOrCancelProps,
};

type CancellationInitializerProps =
  | FinalCancellationProps
  | RescheduleOrCancelProps
  | MultiBookingCancellationProps
  | CancellationUnavailableProps;

export const CancellationInitializer = (props: CancellationInitializerProps): Initializer => {
  const container = Wahanda.Dialogs.getReactContainer();
  const destroy = () => ReactDOM.unmountComponentAtNode(container);

  const render = () => {
    ReactDOM.render(<Reconnect name="AppointmentCancellation" props={props} />, container);
  };

  return { destroy, render };
};
